import React from 'react';
import Particles from 'react-tsparticles';
import { loadSlim } from 'tsparticles-slim';

const ParticlesBackground = () => {
  const particlesInit = async (engine) => {
    await loadSlim(engine);
  };

  return (
    <Particles
      id="tsparticles"
      init={particlesInit}
      options={{
        background: {
          color: "linear-gradient(to right, #6C0606, #A70A0A)" // Match your section background
        },
        fullScreen: { 
          enable: false, // CRUCIAL - Disables fullscreen mode
          zIndex: -1 
        },
        particles: {
          number: {
            value: 80,
            density: {
              enable: true,
              area: 800
            }
          },
          color: {
            value: "#ffffff"
          },
          links: {
            enable: true,
            color: "#ffffff",
            distance: 150,
            opacity: 0.4
          },
          move: {
            enable: true,
            speed: 2
          }
        }
      }}
      style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0
      }}
    />
  );
};

const SoftwareHero = () => {
  return (
    <section className="software-hero" style={{ position: 'relative' }}>
      <ParticlesBackground />
      {/* <h1>Custom Software &<br />Mobile App Development</h1> */}
    </section>
  );
};

export default SoftwareHero;